import React from 'react'
import { Col, List, Row, Typography } from 'antd'
import CustomList from '../../../components/Shared/CustomList'
import CustomVideo from '../../../components/Shared/CustomVideo'
import { GeneralTitle } from '../../../components/Shared'

const { Title, Paragraph } = Typography

const services = [
	'Graphic Illustrations',
	'Visual Design',
	'Print Design',
	'Merchandise Design',
	'Game Art',
	'Video Animation'
]

const GraphicsAndDesign = () => {
	return (
		<>
			<GeneralTitle>Graphics & Design</GeneralTitle>

			<Row gutter={[20, 20]} justify="space-between" align="middle">
				<Col xs={24} sm={24} md={14} lg={14}>
					<Title level={4}>Enhance your brand!</Title>
					<Paragraph>
						Whether you need a rebrand or want to produce some
						quality promotional material, we are a skilled graphic
						design agency with the in-house expertise to create
						designs made to impress.
					</Paragraph>
					<Paragraph>
						Increase your revenue and traffic growth by outsourcing
						all your daily tasks that can be automated.
					</Paragraph>
					<Paragraph>
						Our graphic designers will work with you to produce
						high-quality designs based on your unique requirements.
						We provide you with the ability to speak to your target
						audience through empowering visual designs.
					</Paragraph>
					<Paragraph>Designs to make you stand out.</Paragraph>
					<CustomList
						dataSource={services}
						renderItem={(item) => <List.Item>{item}</List.Item>}
					/>
				</Col>
				<Col xs={24} sm={24} md={10} lg={10}>
					<img
						width="100%"
						src={`${process.env.PUBLIC_URL}/branding/webackit-services-diagram-digital-design.svg`}
						alt="WordPress Services Diagram"
					/>
				</Col>
			</Row>

			<CustomVideo
				src="https://webackit.com/videos/webackit-decade-of-graphic-design-wisdom.mp4"
				type="video/mp4"
				styleProps={{
					width: '100%'
				}}
			/>
		</>
	)
}

export default GraphicsAndDesign
